export enum InvoiceType {
    UNSPECIFIED = 'unspecified',
    EINVOICE = 'einvoice',
    PAPER = 'paper',
}
